module.exports = __webpack_public_path__ + "static/media/backend.972cb8c8.png";